export enum TaskStatus {
  Open = 'open',
  Completed = 'completed',
  Cancelled = 'cancelled',
}
